import React from 'react';
import { StyleSheet, View } from 'react-native';
import AmplitudeMask from 'shared/components/AmplitudeMask/AmplitudeMask';
import Button from 'shared/components/vxl/Button/Button';
import HairLineDivider from 'shared/components/vxl/divider/HairlineDivider/HairLineDivider';
import SectionDivider from 'shared/components/vxl/divider/SectionDivider/SectionDivider';
import { ListItemProps } from 'shared/components/vxl/ListItem/ListItem';
import ListItemGroup from 'shared/components/vxl/ListItemGroup/ListItemGroup';
import theme from 'shared/styles/theme';

export interface ExternalAccountsCardProps {
  title: string;
  items: ListItemProps[];
  footerText: string;
  onFooterPress?: () => void;
}

const ExternalAccountsCard = ({
  title,
  items,
  footerText,
  onFooterPress,
}: ExternalAccountsCardProps) => {
  return (
    <View style={styles.container}>
      <View style={styles.card}>
        <SectionDivider labelText={title}></SectionDivider>
        <AmplitudeMask>
          <ListItemGroup items={items} />
        </AmplitudeMask>
      </View>
      <HairLineDivider />
      <View style={styles.footerContainer}>
        <View style={styles.footer}>
          <Button
            label={footerText}
            onPress={onFooterPress}
            type="TEXT"
            size="LARGE"
            width="HUG"
            analyticsId="manageExternalAccountClicked"
          />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    backgroundColor: theme.color.background.primary,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    overflow: 'hidden',
  },

  container: {
    alignContent: 'center',
    width: '100%',
  },

  footer: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
  },

  footerContainer: {
    backgroundColor: theme.color.background.primary,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    paddingBottom: theme.spacing.s,
    paddingTop: theme.spacing.s,
  },
});

export default ExternalAccountsCard;
